export const formatToCurrency = (amount: number | undefined, sliceNumber = 2) =>
  (amount || 0).toFixed(sliceNumber).replace(/\d(?=(\d{3})+\.)/g, '$& ');

export const priceToNumber = (price: string | number) => +String(price).replace(/[^.\d]/g, '');
